export default "__VITE_ASSET__C3CRPs_U__"